import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import { ModalComponent } from '../../base2';
import {
  AuthUserContext,
  ButtonBar, ErrorMessage, Input,
  ModalFormHeader,
  ScreenHeader, Select
} from '../../components';
import { useCreate, useIndex } from '../../hooks';
import { Person } from '../../types';
import { NewBeneficiaryPage } from '../new-beneficiary-page';

import { NewWillContext } from './new-will-provider';


const petTypes = [
  { label: 'Dog', value: 'dog', id: 'dog' },
  { label: 'Cat', value: 'cat', id: 'cat' },
  { label: 'Bird', value: 'bird', id: 'bird' },
  { label: 'Fish', value: 'fish', id: 'fish' },
  { label: 'Reptile', value: 'reptile', id: 'reptile' },
  { label: 'Other', value: 'other', id: 'other' }
];

export function NewWillAddPetScreen() {
  const navigate = useNavigate();

  const { user } = useContext(AuthUserContext);
  const { will } = useContext(NewWillContext);

  const { data, update } = useIndex('people', { user_id: user?.id });
  const { handleCreate } = useCreate('pet_arrangements');

  const [ careTaker, setCareTaker ] = useState({} as Person);
  const [ showModal, setShowModal ] = useState(false);

  const [ petType, setPetType ] = useState({} as { label: string; value: string; id: string });
  const [ error, setError ] = useState('');

  const handleChange = useCallback((value) => {
    console.log('Selected pet type:', value);
    setPetType(value);
  }, []);

  const handleCareTakerChange = useCallback(
    (careTaker) => {
      console.log('Selected care taker:', careTaker);
      setCareTaker(careTaker);
    },
    []
  );

  const handleBack = useCallback(() => {
    navigate('../pet-arrangements');
  }, [ navigate ]);

  const handleClickableOption = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleNext = useCallback(async () => {
    const petName = (document.getElementById('pet-name') as HTMLInputElement).value;
    const petBreed = (document.getElementById('pet-breed') as HTMLInputElement).value;
    const petAge = (document.getElementById('pet-age') as HTMLInputElement).value;
    const petCareInstructions = (document.getElementById('pet-care-instructions') as HTMLInputElement).value;
    const fund = (document.getElementById('pet-fund') as HTMLInputElement).value;

    if (!petName)
      return setError('Please enter the pet name.');
    if (!petType)
      return setError('Please select a pet type.');
    if (!petBreed)
      return setError('Please enter the pet breed.');
    if (!petAge)
      return setError('Please enter the pet age.');
    if (!petCareInstructions)
      return setError('Please enter care instructions for your pet.');
    if (!careTaker)
      return setError('Please select a care taker for your pet.');

    const pet = {
      will_id: will.id,
      name: petName,
      type: petType.id,
      breed: petBreed,
      age: petAge,
      fund: fund,
      care_instructions: petCareInstructions,
      care_taker_id: careTaker.id
    };

    console.log('pet', pet);

    const result = await handleCreate(pet);
    console.log('Pet Arrangement Created:', result);

    navigate('../pet-arrangements');
  }, [ careTaker, handleCreate, navigate, petType, will.id ]);

  const handleClose = useCallback(() => {
    setShowModal(false);
  }, []);

  const handleSaveCompletion = useCallback(() => {
    setShowModal(false);
    update();
  }, [ update ]);

  const people = data
    .filter((person) => person.linkedUserId !== user?.id);

  const options = people.map((person) => ({
    label: `${person.firstName} ${person.lastName}`,
    ...person
  }));
  
  return (
    <div className="new-will-add-asset-screen screen">
      <ScreenHeader 
        title="Add Pet"
        description="Provide care instructions for your beloved companion"
        handleBack={handleBack} 
        steps={6} 
        step={3} 
      />

      <div className="form-container">
        <ModalFormHeader
          icon="pets"
          header="Pet Details"
        />
        <Input 
          id="pet-name"
          label="Pet Name"
          placeholder="Enter pet name"
        />
        <Select
          id="pet-type"
          label="Pet Type"
          options={petTypes}
          handleChange={handleChange}
          value={petType.value}
        />
        <Input 
          id="pet-breed"
          label="Breed"
          placeholder="Enter the breed of your pet"
        />
        <Input
          id="pet-age"
          label="Age"
          placeholder="Enter the age of your pet"
        />
      </div>
      <div className="form-container">
        <ModalFormHeader
          icon="assignment"
          header="Pet Care"
        />
        <Input
          id="pet-care-instructions"
          label="Care Instructions"
          placeholder="Enter care instructions for your pet"
        />
        <Input
          id="pet-fund"
          label="Care Fund Amount"
          placeholder="Specify the amount to set aside for this pet's care"
        />

        {/* TODO: add multiple care takers */}
        {/* TODO: add fix caretaker display name */}
        <Select
          id="care-taker-select"
          label="Care Taker"
          handleChange={handleCareTakerChange}
          options={options}
          required
          clickableText="Add new care taker"
          selectedOption={{ id: careTaker.id, label: `${careTaker.firstName} ${careTaker.lastName}` }}
          handleClickableOption={handleClickableOption}
        />
      </div>
      <ErrorMessage message={error} />

      <ButtonBar
        handlePrimary={handleNext}
        primaryText="Continue"
      />
            
      <ModalComponent
        closeModal={handleClose}
        contentStyle={{ height: '70%', width: '96%' }}
        showModal={showModal}
      >
        {/* TODO: change to form */}
        <NewBeneficiaryPage handleSaveCompletion={handleSaveCompletion} />
      </ModalComponent>
    </div>
  );
}